import { render, staticRenderFns } from "./SearchResultsDropdownComponent.vue?vue&type=template&id=fbe6c20a"
import script from "./SearchResultsDropdownComponent.vue?vue&type=script&lang=js"
export * from "./SearchResultsDropdownComponent.vue?vue&type=script&lang=js"
import style0 from "./SearchResultsDropdownComponent.vue?vue&type=style&index=0&id=fbe6c20a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports